import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../components/ui/dropdown-menu';
import { toast } from 'sonner';
import {
  Home,
  Briefcase,
  Car,
  Building2,
  Landmark,
  BadgeDollarSign,
  Calculator,
  Phone,
  Mail,
  MapPin,
  ChevronRight,
  CheckCircle2,
  Users,
  Clock,
  Shield,
  ArrowRight,
  Menu,
  X,
  FileText,
  Percent,
  Calendar,
  IndianRupee,
  GraduationCap,
  Cog,
  Truck,
  CreditCard,
  ChevronDown,
  User
} from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LOAN_TYPES_DATA = [
  {
    name: "Housing Loan",
    nameMarathi: "गृहकर्ज / हाउसिंग लोन",
    icon: Home,
    color: "bg-blue-500",
    description: "स्वतःचे घर खरेदी करण्याचे स्वप्न पूर्ण करा. नवीन घर, फ्लॅट किंवा प्लॉट खरेदीसाठी आकर्षक व्याजदरात कर्ज.",
    features: [
      "कमी व्याजदर - 8.5% पासून",
      "30 वर्षांपर्यंत परतफेड कालावधी",
      "90% पर्यंत कर्ज रक्कम",
      "जलद मंजुरी - 7 दिवसांत"
    ],
    eligibility: [
      "वय: 21 ते 65 वर्षे",
      "नोकरदार किंवा व्यावसायिक",
      "किमान मासिक उत्पन्न: ₹25,000",
      "CIBIL Score: 650+"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "बँक स्टेटमेंट (1 वर्ष)",
      "सॅलरी स्लिप / ITR (3 वर्षे)",
      "प्रॉपर्टी दस्तऐवज",
      "पासपोर्ट फोटो (2)",
      "NOC (ग्रामपंचायत/नगरपालिका)"
    ],
    interestRate: "8.5% - 10.5%",
    maxAmount: "₹5 करोड पर्यंत",
    tenure: "30 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    name: "Personal Loan",
    nameMarathi: "वैयक्तिक कर्ज / पर्सनल लोन",
    icon: BadgeDollarSign,
    color: "bg-purple-500",
    description: "कोणत्याही वैयक्तिक गरजेसाठी - लग्न, शिक्षण, वैद्यकीय खर्च, प्रवास किंवा इतर कोणत्याही कारणासाठी.",
    features: [
      "कोणतीही तारण नाही",
      "जलद मंजुरी - 24 तासांत",
      "कमी कागदपत्रे",
      "लवचिक परतफेड पर्याय"
    ],
    eligibility: [
      "वय: 21 ते 58 वर्षे",
      "नोकरदार (किमान 1 वर्ष अनुभव)",
      "किमान मासिक उत्पन्न: ₹20,000",
      "CIBIL Score: 700+"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "बँक स्टेटमेंट (6 महिने)",
      "सॅलरी स्लिप (3 महिने)",
      "पासपोर्ट फोटो (2)",
      "ओळखपत्र (कंपनी ID)"
    ],
    interestRate: "10.5% - 18%",
    maxAmount: "₹25 लाख पर्यंत",
    tenure: "5 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=800&q=80"
  },
  {
    name: "Mortgage Loan",
    nameMarathi: "मॉर्गेज लोन / तारण कर्ज",
    icon: Building2,
    color: "bg-emerald-500",
    description: "तुमच्या मालमत्तेवर कर्ज घ्या - व्यवसाय वाढवण्यासाठी, मुलांच्या शिक्षणासाठी किंवा इतर मोठ्या खर्चासाठी.",
    features: [
      "मालमत्तेच्या 70% पर्यंत कर्ज",
      "कमी व्याजदर",
      "मोठी कर्ज रक्कम",
      "दीर्घ परतफेड कालावधी"
    ],
    eligibility: [
      "वय: 25 ते 65 वर्षे",
      "मालमत्ता मालक असणे आवश्यक",
      "नोकरदार/व्यावसायिक/शेतकरी",
      "मालमत्ता क्लीअर टायटल"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "बँक स्टेटमेंट (1 वर्ष)",
      "मालमत्ता दस्तऐवज (7/12, खरेदीखत)",
      "ITR / सॅलरी स्लिप",
      "NOC (बँक/सोसायटी)",
      "मालमत्ता मूल्यांकन अहवाल",
      "पासपोर्ट फोटो (2)"
    ],
    interestRate: "9% - 12%",
    maxAmount: "₹2 करोड पर्यंत",
    tenure: "15 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&q=80"
  },
  {
    name: "Business Loan",
    nameMarathi: "व्यवसाय कर्ज / बिझनेस लोन",
    icon: Briefcase,
    color: "bg-amber-500",
    description: "तुमचा व्यवसाय वाढवा - कार्यशील भांडवल, यंत्रसामग्री खरेदी, दुकान विस्तार किंवा नवीन व्यवसाय सुरू करण्यासाठी.",
    features: [
      "तारणासह/विना तारण",
      "जलद निधी वितरण",
      "व्यवसाय विस्तारासाठी योग्य",
      "MSME लाभ उपलब्ध"
    ],
    eligibility: [
      "व्यवसाय वय: किमान 2 वर्षे",
      "वार्षिक उलाढाल: ₹10 लाख+",
      "व्यवसाय नोंदणी आवश्यक",
      "GST नोंदणी (लागू असल्यास)"
    ],
    documents: [
      "आधार कार्ड (मालक)",
      "पॅन कार्ड (व्यवसाय + मालक)",
      "व्यवसाय नोंदणी प्रमाणपत्र",
      "बँक स्टेटमेंट (1 वर्ष)",
      "ITR (3 वर्षे)",
      "GST Returns",
      "व्यवसाय प्रोफाइल",
      "मालमत्ता दस्तऐवज (तारण असल्यास)"
    ],
    interestRate: "11% - 16%",
    maxAmount: "₹50 लाख पर्यंत",
    tenure: "7 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80"
  },
  {
    name: "Car Loan",
    nameMarathi: "कार लोन / वाहन कर्ज",
    icon: Car,
    color: "bg-red-500",
    description: "नवीन किंवा जुनी कार खरेदीसाठी सोपे कर्ज. दुचाकी आणि चारचाकी वाहनांसाठी उपलब्ध.",
    features: [
      "100% On-Road Funding",
      "झटपट मंजुरी",
      "कमी EMI पर्याय",
      "नवीन व जुन्या गाड्यांसाठी"
    ],
    eligibility: [
      "वय: 21 ते 60 वर्षे",
      "नोकरदार/व्यावसायिक",
      "किमान उत्पन्न: ₹15,000/महिना",
      "चांगला CIBIL Score"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "बँक स्टेटमेंट (3 महिने)",
      "सॅलरी स्लिप / ITR",
      "पत्ता पुरावा",
      "पासपोर्ट फोटो (2)",
      "वाहन Quotation/Proforma Invoice"
    ],
    interestRate: "8% - 12%",
    maxAmount: "₹1 करोड पर्यंत",
    tenure: "7 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=800&q=80"
  },
  {
    name: "Loan Take Over",
    nameMarathi: "लोन टेक ओवर / बॅलन्स ट्रान्सफर",
    icon: ArrowRight,
    color: "bg-indigo-500",
    description: "तुमचे विद्यमान कर्ज कमी व्याजदरात हस्तांतरित करा. EMI कमी करा आणि पैसे वाचवा.",
    features: [
      "व्याजदर कपात",
      "EMI कमी होते",
      "Top-up सुविधा",
      "सोपी प्रक्रिया"
    ],
    eligibility: [
      "विद्यमान कर्ज चालू असणे",
      "किमान 12 EMI भरलेल्या",
      "चांगला परतफेड इतिहास",
      "CIBIL Score: 700+"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "विद्यमान कर्ज विवरण",
      "बँक स्टेटमेंट (6 महिने)",
      "मूळ कर्ज दस्तऐवज",
      "NOC (विद्यमान बँकेकडून)",
      "मालमत्ता दस्तऐवज"
    ],
    interestRate: "8.5% पासून",
    maxAmount: "विद्यमान कर्ज रक्कम",
    tenure: "शिल्लक कालावधी",
    image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&q=80"
  },
  {
    name: "LAP",
    nameMarathi: "LAP / प्रॉपर्टी वर कर्ज",
    icon: Landmark,
    color: "bg-teal-500",
    description: "Loan Against Property - तुमच्या रहिवासी किंवा व्यावसायिक मालमत्तेवर मोठ्या रकमेचे कर्ज.",
    features: [
      "मालमत्तेच्या 60-70% रक्कम",
      "कमी व्याजदर",
      "दीर्घ परतफेड कालावधी",
      "कोणत्याही कारणासाठी वापर"
    ],
    eligibility: [
      "मालमत्ता मालक असणे",
      "मालमत्ता क्लीअर टायटल",
      "वय: 25 ते 65 वर्षे",
      "स्थिर उत्पन्न स्रोत"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "मालमत्ता दस्तऐवज पूर्ण सेट",
      "7/12 उतारा / इंडेक्स-2",
      "बँक स्टेटमेंट (1 वर्ष)",
      "ITR (3 वर्षे)",
      "NOC (सोसायटी/ग्रामपंचायत)",
      "मालमत्ता कर पावती"
    ],
    interestRate: "9% - 13%",
    maxAmount: "₹5 करोड पर्यंत",
    tenure: "20 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
  },
  {
    name: "Poultry Loan",
    nameMarathi: "पोल्ट्री लोन / कुक्कुटपालन कर्ज",
    icon: BadgeDollarSign,
    color: "bg-orange-500",
    description: "पोल्ट्री फार्म सुरू करण्यासाठी किंवा विस्तारासाठी विशेष कृषी कर्ज. शेतकऱ्यांसाठी सबसिडी उपलब्ध.",
    features: [
      "सरकारी सबसिडी लाभ",
      "कमी व्याजदर",
      "शेतकऱ्यांसाठी विशेष योजना",
      "प्रकल्प अहवाल मदत"
    ],
    eligibility: [
      "शेतकरी/ग्रामीण उद्योजक",
      "जमीन मालकी/भाडेपट्टा",
      "पोल्ट्री अनुभव (प्राधान्य)",
      "प्रकल्प अहवाल आवश्यक"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "7/12 उतारा / 8अ",
      "जमीन NA ऑर्डर",
      "प्रकल्प अहवाल (DPR)",
      "बँक स्टेटमेंट (6 महिने)",
      "पासपोर्ट फोटो (2)",
      "जात प्रमाणपत्र (सबसिडीसाठी)"
    ],
    interestRate: "7% - 11%",
    maxAmount: "₹50 लाख पर्यंत",
    tenure: "7 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=800&q=80"
  },
  {
    name: "Machinery Loan",
    nameMarathi: "यंत्रसामग्री कर्ज / मशीनरी लोन",
    icon: Cog,
    color: "bg-slate-600",
    description: "उद्योग व व्यवसायासाठी यंत्रसामग्री खरेदीसाठी विशेष कर्ज. नवीन किंवा जुनी मशीनरी खरेदीसाठी.",
    features: [
      "नवीन व जुन्या मशीनरीसाठी",
      "90% पर्यंत financing",
      "MSME सबसिडी लाभ",
      "जलद मंजुरी प्रक्रिया"
    ],
    eligibility: [
      "व्यवसाय वय: किमान 2 वर्षे",
      "उद्योग नोंदणी आवश्यक",
      "GST नोंदणी",
      "चांगला क्रेडिट इतिहास"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड (व्यवसाय + मालक)",
      "उद्योग नोंदणी / उद्यम आधार",
      "GST Certificate",
      "बँक स्टेटमेंट (1 वर्ष)",
      "ITR (3 वर्षे)",
      "मशीनरी Quotation",
      "जागा भाडेपट्टा / मालकी पुरावा"
    ],
    interestRate: "9% - 14%",
    maxAmount: "₹2 करोड पर्यंत",
    tenure: "7 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80"
  },
  {
    name: "Education Loan",
    nameMarathi: "शैक्षणिक कर्ज / एज्युकेशन लोन",
    icon: GraduationCap,
    color: "bg-cyan-500",
    description: "उच्च शिक्षणासाठी कर्ज - भारतात किंवा परदेशात. Engineering, Medical, MBA आणि इतर अभ्यासक्रमांसाठी.",
    features: [
      "भारत व परदेशी शिक्षणासाठी",
      "शिक्षण पूर्ण होईपर्यंत EMI नाही",
      "कमी व्याजदर",
      "कोणतेही प्रोसेसिंग शुल्क नाही"
    ],
    eligibility: [
      "विद्यार्थी वय: 18-35 वर्षे",
      "मान्यताप्राप्त संस्थेत प्रवेश",
      "पालक/पती-पत्नी सह-अर्जदार",
      "12वी किमान 50% गुण"
    ],
    documents: [
      "आधार कार्ड (विद्यार्थी + पालक)",
      "पॅन कार्ड",
      "10वी, 12वी मार्कशीट",
      "प्रवेश पत्र (Admission Letter)",
      "Fee Structure",
      "पालकांचे उत्पन्न प्रमाणपत्र",
      "बँक स्टेटमेंट (6 महिने)",
      "पासपोर्ट फोटो (2)"
    ],
    interestRate: "7% - 11%",
    maxAmount: "₹1 करोड पर्यंत",
    tenure: "15 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=800&q=80"
  },
  {
    name: "CC Plus OD",
    nameMarathi: "CC + OD / कॅश क्रेडिट + ओव्हरड्राफ्ट",
    icon: CreditCard,
    color: "bg-violet-500",
    description: "व्यवसायासाठी कार्यशील भांडवल - Cash Credit आणि Overdraft सुविधा. गरजेनुसार पैसे काढा, व्याज फक्त वापरलेल्या रकमेवर.",
    features: [
      "गरजेनुसार पैसे काढा",
      "फक्त वापरलेल्या रकमेवर व्याज",
      "Revolving Credit सुविधा",
      "चेकबुक सुविधा"
    ],
    eligibility: [
      "व्यवसाय वय: किमान 3 वर्षे",
      "वार्षिक उलाढाल: ₹25 लाख+",
      "Current Account आवश्यक",
      "तारण (Stock/Property)"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड (व्यवसाय + मालक)",
      "व्यवसाय नोंदणी प्रमाणपत्र",
      "GST Returns (2 वर्षे)",
      "बँक स्टेटमेंट (1 वर्ष)",
      "ITR व Audit Report (3 वर्षे)",
      "Stock Statement",
      "मालमत्ता दस्तऐवज (तारण)"
    ],
    interestRate: "10% - 15%",
    maxAmount: "₹5 करोड पर्यंत",
    tenure: "वार्षिक नूतनीकरण",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80"
  },
  {
    name: "Commercial Vehicle",
    nameMarathi: "व्यावसायिक वाहन कर्ज",
    icon: Truck,
    color: "bg-rose-500",
    description: "ट्रक, बस, टेम्पो, ट्रेलर आणि इतर व्यावसायिक वाहनांसाठी कर्ज. नवीन व जुन्या वाहनांसाठी.",
    features: [
      "90% पर्यंत financing",
      "नवीन व जुन्या वाहनांसाठी",
      "कमी down payment",
      "जलद मंजुरी"
    ],
    eligibility: [
      "वय: 21 ते 65 वर्षे",
      "वाहन चालक परवाना (Transport)",
      "ट्रान्सपोर्ट व्यवसाय अनुभव",
      "Route Permit (लागू असल्यास)"
    ],
    documents: [
      "आधार कार्ड",
      "पॅन कार्ड",
      "Driving License (Transport)",
      "बँक स्टेटमेंट (6 महिने)",
      "ITR / उत्पन्न प्रमाणपत्र",
      "वाहन Quotation",
      "Route Permit (असल्यास)",
      "पासपोर्ट फोटो (2)"
    ],
    interestRate: "9% - 14%",
    maxAmount: "₹1.5 करोड पर्यंत",
    tenure: "7 वर्षे पर्यंत",
    image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=800&q=80"
  }
];

const LOAN_SUBTYPES = {
  "Housing Loan": ["Purchase", "Construction", "Plot Purchase and Construction", "Plot Purchase", "Commercial Purchase"],
  "Mortgage Loan": ["Commercial Mortgage", "House Mortgage", "Plot Mortgage"]
};

const LandingPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [emiData, setEmiData] = useState({ principal: '', rate: '', tenure: '' });
  const [emiResult, setEmiResult] = useState(null);
  const [contactForm, setContactForm] = useState({
    name: '', phone: '', email: '', loan_type: '', loan_subtype: '', message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [isLoanDialogOpen, setIsLoanDialogOpen] = useState(false);

  const handleLoanTypeChange = (value) => {
    setContactForm(prev => ({ 
      ...prev, 
      loan_type: value, 
      loan_subtype: '' // Reset subtype when loan type changes
    }));
  };

  const calculateEMI = async () => {
    if (!emiData.principal || !emiData.rate || !emiData.tenure) {
      toast.error('Please fill all EMI fields');
      return;
    }
    try {
      const response = await axios.post(`${API}/calculate-emi`, null, {
        params: {
          principal: parseFloat(emiData.principal),
          rate: parseFloat(emiData.rate),
          tenure: parseInt(emiData.tenure)
        }
      });
      setEmiResult(response.data);
    } catch (error) {
      toast.error('Error calculating EMI');
    }
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (!contactForm.name || !contactForm.phone || !contactForm.loan_type) {
      toast.error('Please fill required fields');
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/inquiries`, contactForm);
      toast.success('Inquiry submitted! We will contact you soon.');
      setContactForm({ name: '', phone: '', email: '', loan_type: '', loan_subtype: '', message: '' });
    } catch (error) {
      toast.error('Error submitting inquiry');
    } finally {
      setSubmitting(false);
    }
  };

  const handleLoanClick = (loan) => {
    setSelectedLoan(loan);
    setIsLoanDialogOpen(true);
  };

  const formatCurrency = (amount) => `₹${amount?.toLocaleString('en-IN') || 0}`;

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-brand-navy rounded-lg flex items-center justify-center">
                <span className="text-xl font-bold text-brand-gold font-heading">A</span>
              </div>
              <div>
                <h1 className="font-bold text-brand-navy font-heading text-lg">Atharva Finance</h1>
                <p className="text-xs text-slate-500">Solutions</p>
              </div>
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-8">
              <a href="#services" className="text-slate-600 hover:text-brand-navy transition-colors">Services</a>
              <a href="#calculator" className="text-slate-600 hover:text-brand-navy transition-colors">EMI Calculator</a>
              <a href="#about" className="text-slate-600 hover:text-brand-navy transition-colors">About</a>
              <a href="#contact" className="text-slate-600 hover:text-brand-navy transition-colors">Contact</a>
            </div>

            <div className="hidden md:flex items-center gap-4">
              <Link to="/portal/login">
                <Button variant="outline" data-testid="portal-login-btn" className="border-brand-navy text-brand-navy hover:bg-brand-navy hover:text-white">
                  Customer Login
                </Button>
              </Link>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button data-testid="staff-login-dropdown" className="bg-brand-gold text-brand-navy hover:bg-brand-gold/90 font-semibold">
                    Staff Login <ChevronDown className="ml-2 h-4 w-4" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48">
                  <Link to="/login">
                    <DropdownMenuItem data-testid="admin-login-btn" className="cursor-pointer">
                      <Shield className="mr-2 h-4 w-4" />
                      Admin / Staff
                    </DropdownMenuItem>
                  </Link>
                  <Link to="/employee/login">
                    <DropdownMenuItem data-testid="employee-portal-btn" className="cursor-pointer">
                      <User className="mr-2 h-4 w-4" />
                      Employee Portal
                    </DropdownMenuItem>
                  </Link>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>

            {/* Mobile menu button */}
            <button className="md:hidden p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-slate-100 py-4">
            <div className="px-4 space-y-4">
              <a href="#services" className="block text-slate-600 py-2">Services</a>
              <a href="#calculator" className="block text-slate-600 py-2">EMI Calculator</a>
              <a href="#contact" className="block text-slate-600 py-2">Contact</a>
              <Link to="/portal/login" className="block">
                <Button variant="outline" className="w-full">Customer Login</Button>
              </Link>
              <div className="border-t border-slate-100 pt-4">
                <p className="text-xs text-slate-400 mb-2 px-1">Staff Access</p>
                <Link to="/login" className="block mb-2">
                  <Button className="w-full bg-brand-gold text-brand-navy">Admin / Staff Login</Button>
                </Link>
                <Link to="/employee/login" className="block">
                  <Button variant="outline" className="w-full">Employee Portal</Button>
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-24 pb-16 lg:pt-32 lg:pb-24 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center gap-2 bg-brand-gold/10 text-brand-navy px-4 py-2 rounded-full text-sm font-medium mb-6">
                <CheckCircle2 className="h-4 w-4 text-brand-gold" />
                कमी कागदपत्रे • जलद मंजुरी
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-brand-navy font-heading leading-tight mb-6">
                अथर्व फायनान्स<br />
                <span className="text-brand-gold">सोल्युशन्स</span>
              </h1>
              <p className="text-lg text-slate-600 mb-8 max-w-lg">
                <span className="font-semibold text-brand-navy">Loans Made Simple & Fast.</span> तुमच्या सर्व कर्ज गरजांसाठी विश्वसनीय सेवा - गृहकर्ज, वैयक्तिक कर्ज, व्यवसाय कर्ज आणि बरेच काही.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="#contact">
                  <Button data-testid="apply-now-btn" className="bg-brand-navy text-white hover:bg-brand-navy/90 h-12 px-8 text-base font-semibold shadow-lg shadow-brand-navy/20">
                    Apply Now <ChevronRight className="ml-2 h-5 w-5" />
                  </Button>
                </a>
                <a href="#calculator">
                  <Button variant="outline" className="h-12 px-8 text-base border-2 border-brand-navy text-brand-navy hover:bg-brand-navy hover:text-white">
                    <Calculator className="mr-2 h-5 w-5" /> EMI Calculator
                  </Button>
                </a>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
                alt="Happy family with home keys"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                    <CheckCircle2 className="h-6 w-6 text-emerald-600" />
                  </div>
                  <div>
                    <p className="font-bold text-brand-navy">1000+</p>
                    <p className="text-xs text-slate-500">Happy Customers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-brand-navy font-heading mb-4">
              आमच्या सेवा
            </h2>
            <p className="text-slate-600 max-w-2xl mx-auto">
              सर्व प्रकारच्या कर्जांसाठी एकच ठिकाण - कमी व्याजदर आणि जलद प्रक्रिया
            </p>
            <p className="text-sm text-brand-gold mt-2">
              (माहितीसाठी कार्डवर क्लिक करा)
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {LOAN_TYPES_DATA.map((loan, index) => (
              <Card
                key={index}
                data-testid={`loan-card-${index}`}
                onClick={() => handleLoanClick(loan)}
                className="group cursor-pointer bg-white border border-slate-100 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <CardContent className="p-6">
                  <div className={`w-12 h-12 ${loan.color} rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                    <loan.icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="font-bold text-brand-navy font-heading mb-1">{loan.name}</h3>
                  <p className="text-xs text-brand-gold mb-2">{loan.nameMarathi}</p>
                  <p className="text-sm text-slate-500 line-clamp-2">{loan.description}</p>
                  <div className="mt-4 flex items-center text-brand-navy text-sm font-medium group-hover:text-brand-gold transition-colors">
                    <span>अधिक माहिती</span>
                    <ChevronRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Loan Details Dialog */}
      <Dialog open={isLoanDialogOpen} onOpenChange={setIsLoanDialogOpen}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          {selectedLoan && (
            <>
              <DialogHeader>
                <div className="flex items-center gap-4">
                  <div className={`w-14 h-14 ${selectedLoan.color} rounded-xl flex items-center justify-center`}>
                    <selectedLoan.icon className="h-7 w-7 text-white" />
                  </div>
                  <div>
                    <DialogTitle className="text-2xl font-heading text-brand-navy">
                      {selectedLoan.name}
                    </DialogTitle>
                    <p className="text-brand-gold font-medium">{selectedLoan.nameMarathi}</p>
                  </div>
                </div>
              </DialogHeader>

              {/* Loan Image */}
              <div className="rounded-xl overflow-hidden my-4">
                <img
                  src={selectedLoan.image}
                  alt={selectedLoan.name}
                  className="w-full h-48 object-cover"
                />
              </div>

              {/* Description */}
              <p className="text-slate-600 text-lg mb-6">{selectedLoan.description}</p>

              {/* Key Info Cards */}
              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="bg-slate-50 p-4 rounded-xl text-center">
                  <Percent className="h-6 w-6 text-brand-gold mx-auto mb-2" />
                  <p className="text-xs text-slate-500">व्याजदर</p>
                  <p className="font-bold text-brand-navy">{selectedLoan.interestRate}</p>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl text-center">
                  <IndianRupee className="h-6 w-6 text-brand-gold mx-auto mb-2" />
                  <p className="text-xs text-slate-500">कमाल रक्कम</p>
                  <p className="font-bold text-brand-navy">{selectedLoan.maxAmount}</p>
                </div>
                <div className="bg-slate-50 p-4 rounded-xl text-center">
                  <Calendar className="h-6 w-6 text-brand-gold mx-auto mb-2" />
                  <p className="text-xs text-slate-500">कालावधी</p>
                  <p className="font-bold text-brand-navy">{selectedLoan.tenure}</p>
                </div>
              </div>

              {/* Features */}
              <div className="mb-6">
                <h4 className="font-bold text-brand-navy font-heading mb-3 flex items-center gap-2">
                  <CheckCircle2 className="h-5 w-5 text-emerald-500" />
                  वैशिष्ट्ये
                </h4>
                <div className="grid sm:grid-cols-2 gap-2">
                  {selectedLoan.features.map((feature, i) => (
                    <div key={i} className="flex items-center gap-2 text-slate-600">
                      <CheckCircle2 className="h-4 w-4 text-emerald-500 flex-shrink-0" />
                      <span className="text-sm">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Eligibility */}
              <div className="mb-6">
                <h4 className="font-bold text-brand-navy font-heading mb-3 flex items-center gap-2">
                  <Users className="h-5 w-5 text-blue-500" />
                  पात्रता (Eligibility)
                </h4>
                <div className="grid sm:grid-cols-2 gap-2">
                  {selectedLoan.eligibility.map((item, i) => (
                    <div key={i} className="flex items-center gap-2 text-slate-600">
                      <div className="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0" />
                      <span className="text-sm">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Required Documents */}
              <div className="mb-6">
                <h4 className="font-bold text-brand-navy font-heading mb-3 flex items-center gap-2">
                  <FileText className="h-5 w-5 text-amber-500" />
                  आवश्यक कागदपत्रे (Documents Required)
                </h4>
                <div className="bg-amber-50 p-4 rounded-xl">
                  <div className="grid sm:grid-cols-2 gap-2">
                    {selectedLoan.documents.map((doc, i) => (
                      <div key={i} className="flex items-center gap-2 text-slate-700">
                        <Badge variant="outline" className="bg-white text-amber-700 border-amber-200">
                          {i + 1}
                        </Badge>
                        <span className="text-sm">{doc}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="flex gap-4">
                <a href="#contact" onClick={() => setIsLoanDialogOpen(false)} className="flex-1">
                  <Button className="w-full bg-brand-navy text-white hover:bg-brand-navy/90 h-12 font-semibold">
                    Apply Now
                  </Button>
                </a>
                <a href="tel:7410001036">
                  <Button variant="outline" className="h-12 px-6 border-2 border-brand-navy">
                    <Phone className="h-5 w-5 mr-2" /> Call Us
                  </Button>
                </a>
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>

      {/* EMI Calculator Section */}
      <section id="calculator" className="py-16 lg:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-brand-navy font-heading mb-4">
                EMI Calculator
              </h2>
              <p className="text-slate-600 mb-8">
                तुमच्या कर्जाची मासिक हप्ता (EMI) जाणून घ्या. कर्जाची रक्कम, व्याजदर आणि कालावधी टाका.
              </p>

              <div className="space-y-4">
                <div>
                  <Label className="text-slate-700">Loan Amount (₹)</Label>
                  <Input
                    type="number"
                    placeholder="e.g., 1000000"
                    value={emiData.principal}
                    onChange={(e) => setEmiData(prev => ({ ...prev, principal: e.target.value }))}
                    data-testid="emi-principal"
                    className="h-12 bg-white"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label className="text-slate-700">Interest Rate (% p.a.)</Label>
                    <Input
                      type="number"
                      step="0.1"
                      placeholder="e.g., 8.5"
                      value={emiData.rate}
                      onChange={(e) => setEmiData(prev => ({ ...prev, rate: e.target.value }))}
                      data-testid="emi-rate"
                      className="h-12 bg-white"
                    />
                  </div>
                  <div>
                    <Label className="text-slate-700">Tenure (Months)</Label>
                    <Input
                      type="number"
                      placeholder="e.g., 60"
                      value={emiData.tenure}
                      onChange={(e) => setEmiData(prev => ({ ...prev, tenure: e.target.value }))}
                      data-testid="emi-tenure"
                      className="h-12 bg-white"
                    />
                  </div>
                </div>
                <Button
                  onClick={calculateEMI}
                  data-testid="calculate-emi-btn"
                  className="w-full h-12 bg-brand-navy text-white hover:bg-brand-navy/90 font-semibold"
                >
                  <Calculator className="mr-2 h-5 w-5" /> Calculate EMI
                </Button>
              </div>
            </div>

            <div>
              {emiResult ? (
                <Card className="bg-brand-navy text-white shadow-2xl">
                  <CardContent className="p-8">
                    <h3 className="text-lg font-medium text-slate-300 mb-2">Your Monthly EMI</h3>
                    <p className="text-5xl font-bold text-brand-gold font-heading mb-6">
                      {formatCurrency(emiResult.emi)}
                    </p>
                    <div className="space-y-4 border-t border-white/20 pt-6">
                      <div className="flex justify-between">
                        <span className="text-slate-300">Principal Amount</span>
                        <span className="font-semibold">{formatCurrency(emiResult.principal)}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-slate-300">Total Interest</span>
                        <span className="font-semibold text-amber-400">{formatCurrency(emiResult.total_interest)}</span>
                      </div>
                      <div className="flex justify-between text-lg">
                        <span className="text-slate-300">Total Payment</span>
                        <span className="font-bold text-brand-gold">{formatCurrency(emiResult.total_payment)}</span>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ) : (
                <Card className="bg-white shadow-xl border-0">
                  <CardContent className="p-8 text-center">
                    <Calculator className="h-16 w-16 text-slate-300 mx-auto mb-4" />
                    <p className="text-slate-500">Enter loan details to calculate EMI</p>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section id="about" className="py-16 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-brand-navy font-heading mb-4">
              आम्हाला का निवडावे?
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: Clock, title: "जलद मंजुरी", desc: "24-48 तासांत कर्ज मंजुरी" },
              { icon: Shield, title: "विश्वसनीय सेवा", desc: "पारदर्शक प्रक्रिया" },
              { icon: BadgeDollarSign, title: "कमी व्याजदर", desc: "स्पर्धात्मक दर" },
              { icon: Users, title: "तज्ञ मार्गदर्शन", desc: "अनुभवी टीम" },
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-brand-gold/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <item.icon className="h-8 w-8 text-brand-gold" />
                </div>
                <h3 className="font-bold text-brand-navy font-heading mb-2">{item.title}</h3>
                <p className="text-sm text-slate-500">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 lg:py-24 bg-brand-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="text-white">
              <h2 className="text-3xl sm:text-4xl font-bold font-heading mb-4">
                आजच संपर्क करा
              </h2>
              <p className="text-slate-300 mb-8">
                तुमच्या कर्जाच्या गरजांसाठी आमच्याशी बोला. आम्ही तुम्हाला योग्य मार्गदर्शन करू.
              </p>

              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-brand-gold/20 rounded-lg flex items-center justify-center">
                    <Phone className="h-5 w-5 text-brand-gold" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Call Us</p>
                    <p className="font-semibold">7410001036, 7410001037</p>
                    <p className="font-semibold">7410001038, 7410001039</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-brand-gold/20 rounded-lg flex items-center justify-center">
                    <Mail className="h-5 w-5 text-brand-gold" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Email</p>
                    <p className="font-semibold">info@atharvafs.com</p>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-brand-gold/20 rounded-lg flex items-center justify-center">
                    <MapPin className="h-5 w-5 text-brand-gold" />
                  </div>
                  <div>
                    <p className="text-sm text-slate-400">Address</p>
                    <p className="font-semibold">202, दुसरा मजला, ऑर्किड एन्क्लेव्ह,</p>
                    <p className="font-semibold">4थी गल्ली राजारामपुरी, कोल्हापूर</p>
                  </div>
                </div>
              </div>
            </div>

            <Card className="bg-white shadow-2xl border-0">
              <CardContent className="p-8">
                <h3 className="text-xl font-bold text-brand-navy font-heading mb-6">Loan Inquiry</h3>
                <form onSubmit={handleContactSubmit} className="space-y-4">
                  <div>
                    <Label className="text-slate-700">Full Name *</Label>
                    <Input
                      value={contactForm.name}
                      onChange={(e) => setContactForm(prev => ({ ...prev, name: e.target.value }))}
                      data-testid="contact-name"
                      placeholder="तुमचे नाव"
                      className="h-12"
                      required
                    />
                  </div>
                  <div>
                    <Label className="text-slate-700">Phone Number *</Label>
                    <Input
                      value={contactForm.phone}
                      onChange={(e) => setContactForm(prev => ({ ...prev, phone: e.target.value }))}
                      data-testid="contact-phone"
                      placeholder="Mobile number"
                      className="h-12"
                      required
                    />
                  </div>
                  <div>
                    <Label className="text-slate-700">Email</Label>
                    <Input
                      type="email"
                      value={contactForm.email}
                      onChange={(e) => setContactForm(prev => ({ ...prev, email: e.target.value }))}
                      data-testid="contact-email"
                      placeholder="Email address"
                      className="h-12"
                    />
                  </div>
                  <div>
                    <Label className="text-slate-700">Loan Type *</Label>
                    <Select
                      value={contactForm.loan_type}
                      onValueChange={handleLoanTypeChange}
                    >
                      <SelectTrigger data-testid="contact-loan-type" className="h-12">
                        <SelectValue placeholder="Select loan type" />
                      </SelectTrigger>
                      <SelectContent>
                        {LOAN_TYPES_DATA.map(loan => (
                          <SelectItem key={loan.name} value={loan.name}>{loan.name}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  {LOAN_SUBTYPES[contactForm.loan_type] && (
                    <div>
                      <Label className="text-slate-700">Loan Subtype *</Label>
                      <Select
                        value={contactForm.loan_subtype}
                        onValueChange={(v) => setContactForm(prev => ({ ...prev, loan_subtype: v }))}
                      >
                        <SelectTrigger data-testid="contact-loan-subtype" className="h-12">
                          <SelectValue placeholder="Select subtype" />
                        </SelectTrigger>
                        <SelectContent>
                          {LOAN_SUBTYPES[contactForm.loan_type].map(subtype => (
                            <SelectItem key={subtype} value={subtype}>{subtype}</SelectItem>
                          ))}
                        </SelectContent>
                      </Select>
                    </div>
                  )}
                  <div>
                    <Label className="text-slate-700">Message</Label>
                    <Input
                      value={contactForm.message}
                      onChange={(e) => setContactForm(prev => ({ ...prev, message: e.target.value }))}
                      data-testid="contact-message"
                      placeholder="Additional details..."
                      className="h-12"
                    />
                  </div>
                  <Button
                    type="submit"
                    data-testid="submit-inquiry-btn"
                    className="w-full h-12 bg-brand-navy text-white hover:bg-brand-navy/90 font-semibold"
                    disabled={submitting}
                  >
                    {submitting ? 'Submitting...' : 'Submit Inquiry'}
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-brand-navy-light py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <span className="text-lg font-bold text-brand-navy">A</span>
              </div>
              <span className="text-white font-semibold">Atharva Finance Solutions</span>
            </div>
            <p className="text-slate-400 text-sm">
              © 2024 Atharva Finance Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
